import axios from '@/libs/api.request'

export const getBomsByProductId = ({ productId, display, includes }) => {
  let includeQueryBuilder = []
  let url = `bom/products/${productId}` + (display ? '?display=' + display : '')

  if (includes && includes.length > 0) {
    includes.forEach(function (attr) {
      includeQueryBuilder.push('includes[]=' + attr)
    })
    url = url + (display ? '&' + includeQueryBuilder.join('&') : '?' + includeQueryBuilder.join('&'))
  }

  return axios.request({
    url: url,
    method: 'get'
  })
}

export const getBomVersions = (currentBomId) => {
  return axios.request({
    url: `bom/${currentBomId}/versions`,
    method: 'get'
  })
}

export const getCustomerProvidedByBom = (bomId) => {
  return axios.request({
    url: `/customer-provided-parts/by-bom/${bomId}`,
    method: 'get'
  })
}

export const loadPartsFromOctopart = (bomId) => {
  return axios.request({
    method: 'post',
    url: `/bom/${bomId}/match-parts-in-external-db`
  })
}

export const downloadBOM = (bomId) => {
  return axios.request({
    url: `/bom/${bomId}/download`,
    method: 'post',
    responseType: 'blob'
  })
}

export const runBOMProsecutor = (bomId, checkers, version = '', partNumber = '') => {
  return axios.request({
    url: `/bom-prosecutor`,
    data: { bom_id: bomId, checkers: checkers, version: version, part_number: partNumber },
    method: 'post'
  })
}

export const getBomByAssemblyPartId = (assemblyPartId, params = {}) => {
  return axios.request({
    url: `bom/parts/${assemblyPartId}`,
    method: 'get',
    params: params
  })
}
